import { render, staticRenderFns } from "./aftersaleDetail.vue?vue&type=template&id=2c7f0bbe&scoped=true"
import script from "./aftersaleDetail.vue?vue&type=script&lang=js"
export * from "./aftersaleDetail.vue?vue&type=script&lang=js"
import style0 from "./aftersaleDetail.vue?vue&type=style&index=0&id=2c7f0bbe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f0bbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7f0bbe')) {
      api.createRecord('2c7f0bbe', component.options)
    } else {
      api.reload('2c7f0bbe', component.options)
    }
    module.hot.accept("./aftersaleDetail.vue?vue&type=template&id=2c7f0bbe&scoped=true", function () {
      api.rerender('2c7f0bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersale/aftersaleDetail.vue"
export default component.exports